import { CSSObject } from '@mantine/core'
import { MantineThemeComponents } from '@mantine/styles/lib/theme/types/MantineTheme'
import { getButtonStyles } from '../helpers/buttonHelpers'

export const Button: MantineThemeComponents['Button'] = {
    styles: (__, _, runtimeProps): Record<string, CSSObject> => {
        return getButtonStyles(runtimeProps)
    }
}
